'use strict'

const foundModalItemsMixin = {
    data() {
        return {
            foundItems: [],
            itemExistsModal: false,
            allowCreateNewAnyway: false,
        }
    },
    watch: {
        '$store.state.secondLayerIsOpened'(value) {
            if (this.modalLayer !== 1) return
            if (!value) {
                if (this.itemExistsModal) {
                    this.closeItemExistsModal()
                }
            }
        },
        '$store.state.thirdLayerIsOpened'(value) {
            if (this.modalLayer !== 2) return
            if (!value) {
                if (this.itemExistsModal) {
                    this.closeItemExistsModal()
                }
            }
        },
    },
    methods: {
        selectExistingItem(item) {
            if (!item) return
            this.submitted = false
            this.createItemData(item)
        },
        openItemExistsModal() {
            this.itemExistsModal = true
            if (this.modalLayer === 2) {
                this.$store.commit('toggleThirdLayer', true)
            } else if (this.modalLayer === 1) {
                this.$store.commit('toggleSecondLayer', true)
            }
        },
        closeItemExistsModal() {
            this.itemExistsModal = false
            if (this.modalLayer === 2) {
                this.$store.commit('toggleThirdLayer', false)
            } else if (this.modalLayer === 1) {
                this.$store.commit('toggleSecondLayer', false)
            }
        },
    }
}

export default foundModalItemsMixin
